module.exports = __webpack_public_path__ + "img/sites-seen-logo-5.6d54a2f4.png";